import { useState } from "react";

import type { ProductCatalogItem } from "@/catalog";

export function CompanyLogo({ item }: { item: Pick<ProductCatalogItem, "name" | "logoUrl"> }) {
  const [failed, setFailed] = useState(false);
  if (!item.logoUrl || failed) return <span className="logo-fallback">{item.name.slice(0, 2).toUpperCase()}</span>;
  return <img className="company-logo" src={item.logoUrl} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />;
}
